import { createOutlineText, scaleToFit } from '../../../Utils/Utils';
import { ButtonColors, NineSliceButton } from './NineSliceButton';

export interface ITextConstructionParameters {
    width: number;
    height: number;
    btnText: string;
    color?: ButtonColors;
    outline?: number;
    stroke?: number;
    fontSize?: number;
    lineGap?: number;
}

export class TextButton extends NineSliceButton {
    public set text(value: string) {
        const txt = this.textComponent;
        txt.text = value;
    }

    public get text() {
        return this.textComponent.text;
    }

    protected readonly textComponent: PIXI.Text;

    constructor({
        width,
        height,
        btnText,
        color = ButtonColors.GREEN,
        outline = 0x005566,
        stroke = 8,
        fontSize = 60,
        lineGap = 60,
    }: ITextConstructionParameters) {
        super(color, 270, 100);
        const buttonScale = scaleToFit(270, 100, width, height);
        this.scale.set(buttonScale);
        this.originalScale.set(buttonScale, buttonScale);
        const txt = createOutlineText(
            btnText,
            new PIXI.Rectangle(0, 0, width * 2, height),
            'Baloo',
            fontSize,
            lineGap,
            0xffffff,
            outline,
            stroke
        );

        const scale = scaleToFit(txt.width, txt.height, width * 0.9, height);
        txt.scale.set(Math.min(scale, 0.8));
        this.textComponent = txt;
        this.addChild(txt);
    }
}
